export const GET_LIST_VIDEOS = '/video/list';
export const GET_VIDEO_INFO = '/video/getById';
export const CREATE_VIDEO = '/video/create';
export const UPDATE_VIDEO = '/video/update';
export const DELETE_VIDEO = '/video/delete';
